import React from 'react';
import styled from 'styled-components';

import { Row, Col, FlexView, COLORS, Separator } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Wrapper = styled(FlexView)`
  border: 1px solid ${COLORS.GHOST};
  border-radius: 16px;
`;
const ContainWrapper = styled(FlexView)`
  padding: 12px 16px;
`;

const Tag = styled(FlexView)`
  height: 36px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background: ${({ color }) => color};
`;

const WrappedText = styled(Text)`
  word-wrap: break-word;
`;

function ObservationCard({ color, heading, info, tag }) {
  return (
    <Wrapper>
      <Tag alignItems="center" justifyContent="center" color={color}>
        <Text variant="eyebrow2">{tag}</Text>
      </Tag>
      <ContainWrapper>
        {heading && (
          <Row alignItems="center">
            <Col gutter={0}>
              <Text variant="h6">{heading}</Text>
            </Col>
          </Row>
        )}
        <Separator height={8} transparent />

        <WrappedText variant="body2" style={{ wordWrap: 'break-word' }}>
          {info}
        </WrappedText>
      </ContainWrapper>
    </Wrapper>
  );
}

export default ObservationCard;
